import React, { useEffect, useRef } from 'react';
import ApexCharts from 'apexcharts';
import { useTheme } from '@mui/material/styles'; 
import PropTypes from 'prop-types'; // Import PropTypes

const PieChart = ({ data }) => {
    const chartRef = useRef(null);
    const balancetenure = parseFloat(data.balancetenure) || 0;
    const term = parseFloat(data.term) || 0;
    const paidTerm = term - balancetenure;
    const theme = useTheme(); 

    useEffect(() => {
        const options = {
            chart: {
                type: 'pie',
                width: 340,
                redrawOnParentResize: true,
            },
            series: [paidTerm, balancetenure],
            labels: ['Paid Term', 'Balance Term'],
            colors: ['#9B134A', 'rgb(185, 80, 71)'],
            dataLabels: {
                enabled: true,
                formatter: (val, opts) => {
                    return `${opts.w.globals.series[opts.seriesIndex]}`;
                },
                style: {
                    colors: ['white'], 
                    fontSize: '14px',
                    fontWeight: 'bold',
                },
                dropShadow: {
                    enabled: true,
                },
                position: 'inside', 
                offsetX: 0,
                offsetY: 0,
                textAnchor: 'middle',
            },
            tooltip: {
                enabled: false,
                y: {
                    formatter: function (val) {
                        return `${val}`;
                    },
                },
            },
            plotOptions: {
                pie: {
                    expandOnClick: false,
                    dataLabels: {
                        offset: -20, 
                    },
                },
            },
            legend: {
                labels: {
                    colors: 'white' 
                },
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 300,
                    },
                    legend: {
                        position: 'bottom',
                        labels: {
                            colors: [theme.palette.text.primary],
                        },
                    },
                },
            }],
        };

        const chart = new ApexCharts(chartRef.current, options);
        chart.render();
         const overrideLabelColors = () => {
            const labels = chartRef.current.querySelectorAll(' .apexcharts-legend-text');
            labels.forEach((label) => {
                label.style.color = theme.palette.text.primary;
            });
        };

        overrideLabelColors();
        return () => {
            chart.destroy();
        };
    }, [term, balancetenure, theme]); 

    return (
        <div ref={chartRef} className='changeGraph' />
    );
};

    // PropTypes validation
    PieChart.propTypes = {
        data: PropTypes.shape({
            balancetenure: PropTypes.string,
            term: PropTypes.number,
        }).isRequired,
    };

export default PieChart;